import React from 'react';
import { connect } from 'react-redux';
// Components
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles, withTheme, WithStyles, WithTheme } from '@material-ui/core/styles';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import ExitIcon from '@material-ui/icons/ExitToApp';
import ViadialogIcon from '@material-ui/icons/HeadsetMic';
import SnowIcon from '@material-ui/icons/AcUnit';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
// Module
import { actions as loginActions } from '../../redux/reducers/login';
import { actions as viadialogActions } from '../../redux/reducers/viaDialog';
import { actions as homeActions, selectors as homeSelectors } from '../../redux/reducers/home';
import { ConnectFreeSeatingResponse } from '../../redux/reducers/api-types';
// Ressources
import UserUtils, { AccountRight, AccountType, RightDef, RightRank } from '../../utils/userUtils';
import packageJson from '../../../package.json';
import * as Images from '../../assets/images';
import defaultTheme from '../../assets/styles/theme';
import { getHistory } from '../../utils/historyUtils';
import ObjectUtils from '../../utils/objectUtils';
import StringUtils from '../../utils/stringUtils';
import WindowUtils from '../../utils/windowUtils';
import { paths } from '../../routes/paths';
import styles from './menu-drawer-style';
import { clsx } from '../../utils/htmlUtils';
import envConfig from '../../config';

export interface MyMenuItem {
    icon: string;
    auth?: AccountType[];
    rights?: RightDef[];
    customIcon?: string;
    color?: string;
    colorActiveLabel?: string;
    active?: string;
    to?: string;
    label: string;
    collapseKey?: string;
    items?: SubMenu[];
    checkRoles?: () => boolean;
}

export interface SubMenu {
    label: string;
    collapseKey: string;
    subItems: SubMenuItem[];
}

export interface SubMenuItem {
    to?: string;
    icon: string;
    label: string;
    active?: string;
    customIcon?: string;
    checkRoles?: () => boolean;
}

// Menu visible for everyone
export function getMenu(t: any): MyMenuItem[] {
    // const beta = ' (Beta)';
    let menu: MyMenuItem[] = [
        {
            icon: 'home',
            // customIcon: Images.HomeIcon,
            color: defaultTheme.palette.colors.home,
            to: paths.home,
            label: t('menu:home'),
        },
        {
            icon: 'emoji_transportation',
            // customIcon: Images.PartnerIcon,
            color: defaultTheme.palette.colors.partners,
            colorActiveLabel: defaultTheme.palette.colors.black,
            auth: [AccountType.Admin],
            to: paths.partners,
            label: t('menu:partners'),
        },
        {
            icon: 'supervised_user_circle',
            // customIcon: Images.DriverIcon,
            color: defaultTheme.palette.colors.drivers,
            auth: [AccountType.Admin, AccountType.Operator],
            to: paths.drivers,
            label: t('menu:drivers'),
        },
        {
            icon: 'directions_car',
            color: defaultTheme.palette.colors.vehicles,
            auth: [AccountType.Admin],
            collapseKey: 'vehicle',
            label: t('menu:vehicles'),
            items: [
                {
                    label: t('menu:vehicles_admin'),
                    collapseKey: 'vehicle_admin',
                    subItems: [
                        {
                            icon: 'directions_car',
                            to: paths.vehicles,
                            label: t('menu:vehicles'),
                        },
                        {
                            icon: 'directions_car',
                            to: paths.vehiclesTypes,
                            label: t('menu:vehicles_types'),
                        },
                    ],
                },
            ],
        },
        {
            icon: 'perm_identity',
            // customIcon: Images.RiderIcon,
            color: defaultTheme.palette.colors.riders,
            auth: [AccountType.Admin, AccountType.Operator],
            to: paths.riders,
            label: t('menu:riders'),
        },
        {
            icon: 'perm_identity_filled',
            // customIcon: Images.RiderIcon,
            color: defaultTheme.palette.colors.riders,
            auth: [AccountType.Admin, AccountType.Operator],
            to: paths.users,
            label: t('menu:riders') + ' New',
        },
        {
            icon: 'card_travel',
            // customIcon: Images.CompanyIcon,
            color: defaultTheme.palette.colors.companies,
            auth: [AccountType.Admin],
            to: paths.companies,
            label: t('menu:companies'),
        },
        {
            icon: 'card_travel_filled',
            // customIcon: Images.CompanyIcon,
            color: defaultTheme.palette.colors.companies,
            auth: [AccountType.Admin],
            to: paths.contracts,
            label: t('menu:companies') + ' New',
        },
        // {
        //     icon: 'accessible_forward',
        //     // customIcon: Images.ReservationIcon,
        //     color: defaultTheme.palette.colors.reservations,
        //     colorActiveLabel: defaultTheme.palette.colors.black,
        //     auth: [AccountType.Admin, AccountType.Operator],
        //     rights: [{ name: AccountRight.RIDE_VIEW }],
        //     to: paths.rides,
        //     label: t('menu:rides'),
        // },
        {
            icon: 'date_range',
            // customIcon: Images.ReservationIcon,
            color: defaultTheme.palette.colors.reservations,
            colorActiveLabel: defaultTheme.palette.colors.black,
            auth: [AccountType.Admin, AccountType.Operator],
            rights: [{ name: AccountRight.RIDE_VIEW }],
            to: paths.reservations,
            label: t('menu:reservations'),
        },
        {
            icon: 'navigation',
            // customIcon: Images.CourseIcon,
            color: defaultTheme.palette.colors.bookings,
            colorActiveLabel: defaultTheme.palette.colors.black,
            auth: [AccountType.Admin, AccountType.Operator],
            rights: [{ name: AccountRight.RIDE_VIEW }],
            to: paths.bookings,
            label: t('menu:bookings'),
        },
        {
            icon: 'description',
            // customIcon: Images.BillingIcon,
            color: defaultTheme.palette.colors.bills,
            auth: [AccountType.Admin],
            collapseKey: 'billing',
            label: t('menu:bills'),
            items: [
                {
                    label: t('menu:client_bills'),
                    collapseKey: 'client_bills',
                    subItems: [
                        {
                            icon: 'description',
                            active: paths.billsSimple,
                            to: paths.billsSimple,
                            label: t('menu:client_bills_simple'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsPeriodsPending,
                            label: t('menu:client_bills_grouped_pending'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsPeriods,
                            label: t('menu:client_bills_grouped'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsCreditNotes,
                            label: t('menu:client_bills_refund'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsMonthCreditNotes,
                            label: t('menu:credit_notes_month'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsExceptionalCreditNotes,
                            label: t('menu:exceptional_notes_month'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsRectifications,
                            label: t('menu:rectifications'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsExceptionals,
                            label: t('menu:exceptionals'),
                        },
                    ],
                },
                {
                    label: t('menu:partner_bills'),
                    collapseKey: 'partner_bills',
                    subItems: [
                        {
                            icon: 'description',
                            to: paths.billsPartnerPending,
                            label: t('menu:partner_bills_pending'),
                        },
                        {
                            icon: 'description',
                            to: paths.billsPartner,
                            label: t('menu:partner_bills_all'),
                        },
                    ],
                },
            ],
        },
        // {
        //     icon: 'payment',
        //     // customIcon: Images.SnappayIcon,
        //     color: defaultTheme.palette.colors.snappay,
        //     colorActiveLabel: defaultTheme.palette.colors.black,
        //     auth: [AccountType.Admin],
        //     to: paths.snappay,
        //     label: t('menu:snappay'),
        // },
        {
            icon: 'local_atm',
            color: defaultTheme.palette.colors.pricing,
            auth: [AccountType.Admin],
            rights: [{ name: AccountRight.PRICING_MGMT, mode: RightRank.R }],
            label: t('menu:pricing'),
            collapseKey: 'pricing',
            items: [
                {
                    label: t('menu:pricing'),
                    collapseKey: 'pricing_admin',
                    subItems: [
                        {
                            icon: 'local_atm',
                            to: paths.pricingManageAreas,
                            label: t('menu:manage_areas'),
                        },
                        {
                            icon: 'local_atm',
                            to: paths.pricingManagePrices,
                            label: t('menu:manage_prices'),
                        },
                        {
                            icon: 'local_atm',
                            to: paths.pricingManageFees,
                            label: t('menu:manage_fees'),
                        },
                    ],
                },
            ],
        },
        {
            icon: 'pin_drop',
            color: defaultTheme.palette.colors.prebooks,
            auth: [AccountType.Admin],
            label: t('menu:operations'),
            collapseKey: 'operations',
            items: [
                {
                    label: t('menu:operations'),
                    collapseKey: 'operations_admin',
                    subItems: [
                        {
                            icon: 'schedule',
                            to: paths.prebooks,
                            label: t('menu:prebooks'),
                        },
                        {
                            icon: 'blur_circular',
                            to: paths.controlTowers,
                            label: t('menu:control_towers'),
                        },
                        {
                            icon: 'blur_circular',
                            to: paths.ranks,
                            label: t('menu:ranks'),
                        },
                        {
                            icon: 'add_circle_outline',
                            to: paths.ridesImport,
                            label: t('menu:rides_import'),
                        },
                        {
                            icon: 'campaign',
                            to: paths.driverCommunications,
                            label: t('menu:driver_communications'),
                            checkRoles: () => UserUtils.hasRoleOpsOrGod(),
                        },
                    ],
                },
            ],
        },
        // {
        //     icon: 'list',
        //     color: defaultTheme.palette.colors.snappay,
        //     auth: [AccountType.Admin],
        //     to: paths.ranks,
        //     label: t('menu:ranks') + beta,
        // },
        {
            icon: 'monetization_on',
            color: defaultTheme.palette.colors.marketing,
            colorActiveLabel: defaultTheme.palette.colors.black,
            auth: [AccountType.Admin],
            label: t('menu:marketing'),
            collapseKey: 'marketing',
            items: [
                {
                    label: t('menu:marketing'),
                    collapseKey: 'marketing_promo',
                    subItems: [
                        // {
                        //     icon: 'monetization_on',
                        //     to: paths.marketingPromos,
                        //     label: t('menu:promos'),
                        // },
                        {
                            icon: 'monetization_on',
                            to: paths.marketingFidB2C,
                            label: t('menu:fidb2c'),
                        },
                    ],
                },
            ],
        },
        {
            icon: 'bug_report',
            color: defaultTheme.palette.colors.ticketing,
            auth: [AccountType.Admin, AccountType.Operator],
            label: t('menu:support'),
            collapseKey: 'ticketing',
            items: [
                // {
                //     label: t('menu:ticketing'),
                //     collapseKey: 'ticketing_projects',
                //     subItems: [
                //         {
                //             icon: 'bug_report',
                //             to: `${paths.ticketing}?project=customer`,
                //             label: t('menu:ticketing_customer'),
                //         },
                //         {
                //             icon: 'bug_report',
                //             to: `${paths.ticketing}?project=driver`,
                //             label: t('menu:ticketing_driver'),
                //         },
                //     ],
                // },
                {
                    label: t('menu:support'),
                    collapseKey: 'support',
                    subItems: [
                        {
                            icon: 'description',
                            to: paths.support,
                            label: t('menu:cypher'),
                        },
                    ],
                },
            ],
        },
        {
            icon: 'security',
            color: defaultTheme.palette.colors.snappay,
            checkRoles: () => UserUtils.hasRoleAdminIDOrGod(),
            auth: [AccountType.Admin],
            to: paths.admin,
            label: t('menu:admin'),
        },
        {
            icon: 'phone',
            color: defaultTheme.palette.colors.reserver,
            colorActiveLabel: defaultTheme.palette.colors.white,
            auth: [AccountType.Admin, AccountType.Operator],
            to: paths.reserver,
            label: t('menu:reserver'),
        },
        // {
        //     icon: 'platform',
        //     customIcon: Images.SnappayIcon,
        //     color: defaultTheme.palette.colors.snappay,
        //     auth: [AccountType.Admin],
        //     label: t('menu:platform'),
        //     collapseKey: 'platform',
        //     items: [
        //         {
        //             label: t('menu:platform'),
        //             collapseKey: 'platform_admin',
        //             subItems: [
        //                 {
        //                     icon: 'directions_car',
        //                     customIcon: Images.SnappayIcon,
        //                     to: '/platform/corp_driver',
        //                     label: t('menu:platform_corp_driver'),
        //                 },
        //                 {
        //                     icon: 'directions_car',
        //                     customIcon: Images.SnappayIcon,
        //                     to: '/platform/partner_driver',
        //                     label: t('menu:platform_partner_driver'),
        //                 },
        //             ],
        //         },
        //     ],
        // },
        {
            icon: 'faceIcon',
            color: defaultTheme.palette.colors.profil,
            colorActiveLabel: defaultTheme.palette.colors.white,
            to: paths.profil,
            label: t('menu:open_profile'),
        },
    ];

    if (UserUtils.isOperator()) {
        menu = menu.filter((m) => !m.auth || m.auth.includes(AccountType.Operator));
    }

    const userRights = UserUtils.getRights();

    return menu
        .filter((m) => (!m.rights || UserUtils.hasRights(userRights, m.rights)) && (!m.checkRoles || m.checkRoles()))
        .map((m) =>
            m.items
                ? {
                      ...m,
                      items: m.items.map((item) => ({
                          ...item,
                          subItems: item.subItems.filter((sub) => !sub.checkRoles || sub.checkRoles()),
                      })),
                  }
                : m,
        );
}

export const Logo = (
    path: string,
    { marginRight = 8, fill = '#B2B2B2', ...rest }: any = {},
    size: number = 24,
): React.ReactNode => {
    return <img src={path} alt="menu-icon" style={{ ...rest, fill, marginRight }} width={size} height={size} />;
};

export function getItemWithColor(t: any, path: string = window.location.pathname): MyMenuItem {
    const pathStartWith = (x: MyMenuItem): boolean => x.to !== paths.home && path.startsWith(x.active || x.to);

    const menu: MyMenuItem[] = getMenu(t);

    // Home case we can directly find it
    if (path === paths.home) {
        return menu.find((x) => x.to === path);
    }
    let found: MyMenuItem = menu.find(pathStartWith);
    if (found) {
        return found;
    }

    dance: for (const e of menu.filter((e) => e.items)) {
        for (const item of e.items) {
            found = item.subItems.find(pathStartWith);
            if (found) {
                found = {
                    ...found,
                    color: e.color,
                    colorActiveLabel: e.colorActiveLabel,
                };
                break dance;
            }
        }
    }
    return found;
}

interface MenuDrawerProps extends WithTranslation, WithStyles, WithTheme {
    isEvent: { isActive: boolean; raining: boolean; onChange: () => void };
    favorites: any;
    getUserStorage: (key: string) => any;
    getAllUserStorage: () => any;
    toggleFavorite: (path: string, name?: string, removeIfExist?: boolean) => any;
    removeUserStorage: (key: string) => any;
    clearUserStorage: () => any;
    logout: () => any;
    logoutBO: () => any;
    disconnectFreeSeatingUser: (callback: React.EffectCallback) => any;
}

const MenuDrawer: React.FC<MenuDrawerProps> = React.memo((props): JSX.Element => {
    const { t, classes, theme, favorites, children, isEvent } = props;

    const subMenus: any = {};

    const [mobileOpen, setMobileOpen] = React.useState<boolean>(false);

    const [activeSubMenu, setActiveSubMenu] = React.useState(null); // Change to open submenu by default
    const [subMenuOpened, setSubMenuOpened] = React.useState<boolean>(false);
    const [opennedItems, setOpennedItems] = React.useState(getInitOpennedItems());
    const [showMenuLabel, setShowMenuLabel] = React.useState<boolean>(false);

    const handleDrawerToggle = (): void => setMobileOpen(!mobileOpen);

    const toggleList = (page, val?) => {
        setOpennedItems({ ...opennedItems, [page]: val || !opennedItems[page] });
        if (val) {
            setActiveSubMenu(page);
        }
    };

    const hoverMenu = (hover) => () => {
        if (!subMenuOpened && !anchorEl) {
            setShowMenuLabel(hover);
        }
    };

    const toogleSubMenu = (page?) => (e) => {
        if (subMenuOpened) {
            // Either we close the menu or we tap again on the same menu with subMenus
            if (!page || page === activeSubMenu) {
                setSubMenuOpened(!subMenuOpened);
            }
        } else {
            setSubMenuOpened(!subMenuOpened);
        }
        if (page) {
            toggleList(page, true);
        }
    };

    const showMenuItemOptions = (item: any) => (e: React.MouseEvent) => {
        e.preventDefault();
        setAnchorEl({ item: item, elt: e.target });
    };

    function hideMenuItemOptions(e: React.MouseEvent) {
        e.preventDefault();
        setAnchorEl(null);
    }
    const openMenuItem = (item: any) => (e) => {
        getHistory().push(item.to);
        setAnchorEl(null);
    };

    // Favorite
    const addOrRemoveFavorites = (item: any) => (e) => {
        props.toggleFavorite(item.to);
        setAnchorEl(null);
    };

    const [anchorEl, setAnchorEl] = React.useState(null);

    function getInitOpennedItems() {
        let res: any = {};
        const path: string = window.location.pathname;
        const items: any[] = [
            { test: path.startsWith(paths.billsPartner), key: 'partner_bills' },
            {
                test: !path.startsWith(paths.billsPartner) && path.startsWith(`${paths.bills}/`),
                key: 'client_bills',
            },
            { test: path.startsWith(paths.vehicles), key: 'vehicle_admin' },
        ];

        items.forEach((item) => {
            const { test, key } = item;
            if (test) {
                res = { ...res, [key]: true };
            }
        });

        // Open sub menus at start if none is opened
        if (ObjectUtils.isEmpty(res)) {
            const menu: MyMenuItem[] = getMenu((v) => v).filter((m) => m.items);
            menu.forEach((item) => {
                item.items.forEach((sub) => {
                    res = { ...res, [sub.collapseKey]: true };
                });
            });
        }
        return res;
    }

    function isActivePath(target: string, targets?: SubMenu[]): string {
        const { classes } = props;
        const path: string = window.location.pathname;
        const pathSearch: string = window.location.pathname + window.location.search;

        // Paths that overlaps has to be declared here (like /vehicles and /vehicles/types)
        const exactPath: string[] = [paths.home, paths.billsPartner, paths.billsPeriods, paths.vehicles];

        const find = exactPath.findIndex((p) => p === target);
        if (
            target &&
            ((find !== -1 && path === target) ||
                (find === -1 && (path.startsWith(target) || pathSearch.startsWith(target))))
        ) {
            return classes.selected;
        } else if (targets) {
            // Menus with more than one element
            for (let i = 0; i < targets.length; i++) {
                const element = targets[i];
                for (let j = 0; j < element.subItems.length; j++) {
                    const subElement = element.subItems[j];
                    const t = subElement.active || subElement.to;
                    if (path.startsWith(t) || pathSearch.startsWith(t)) {
                        return classes.selected;
                    }
                }
            }
        }
        return '';
    }

    //=======================================//
    //=============== Actions ===============//
    //=======================================//

    const handleLogout = () => {
        // props.logout();
        props.logoutBO();
    };

    const handleOpenViadialog = () => {
        const infos: ConnectFreeSeatingResponse = UserUtils.getFreeSeatingInfos();
        if (infos?.access_token) {
            WindowUtils.openViadialog(infos.access_token);
        }
    };

    const handleToogleList = (collapseKey) => (e) => {
        toggleList(collapseKey);
    };

    const connectedUser = UserUtils.getUser();
    // const fullname = connectedUser?.user ? `${StringUtils.userFullname(connectedUser.user)}` : 'Who r u ?'
    const accountType: string = connectedUser?.user?.type
        ? `${StringUtils.upperFirst(connectedUser.user.type)}`
        : '??? What °0_o';

    const items: MyMenuItem[] = getMenu(t);

    const renderItems = (): JSX.Element[] => {
        return items.map((item) => {
            let subMenu = null;

            if (item.items?.length > 0) {
                subMenu = renderSubMenu(item.items);
                if (mobileOpen) {
                    return subMenu;
                }
                subMenus[item.collapseKey] = subMenu;
            }

            const color = getItemWithColor(t)?.color;
            const isActive = subMenu ? isActivePath(null, item.items) : isActivePath(item.active || item.to);

            const iconView = item.customIcon ? (
                Logo(item.customIcon, isActive ? { stroke: '#1B1B1B' } : {})
            ) : (
                <div style={{ color: isActive && item?.colorActiveLabel ? item?.colorActiveLabel : 'white' }}>
                    <Icon>{item.icon}</Icon>
                </div>
            );
            const labelView = (mobileOpen || showMenuLabel) && item.label;
            const optionsView =
                labelView && favorites ? (
                    <>
                        <Icon className="menuItemOption" onClick={showMenuItemOptions(item)}>
                            more_vert
                        </Icon>
                    </>
                ) : null;

            const colorLabel = isActive ? item?.colorActiveLabel || 'inherit' : 'inherit';

            return (
                <ListItem key={item.icon}>
                    {subMenu ? (
                        <Button
                            className={isActive}
                            id={item.label}
                            style={isActive && color ? { backgroundColor: color } : {}}
                            onClick={toogleSubMenu(item.collapseKey)}
                        >
                            {iconView}
                            <span style={{ color: colorLabel }}>{labelView}</span>
                        </Button>
                    ) : (
                        <Button
                            component={RouterLink}
                            id={item.label}
                            className={isActive}
                            style={isActive && color ? { backgroundColor: color } : {}}
                            to={item.to}
                        >
                            {iconView}
                            <span style={{ color: colorLabel }}>{labelView}</span>
                            {optionsView}
                        </Button>
                    )}
                </ListItem>
            );
        });
    };

    const renderSubMenu = (items: SubMenu[]): JSX.Element[] => {
        return items.map((sub, index) => {
            const subView = (mobileOpen || showMenuLabel) && <Button>{sub.label}</Button>;
            return (
                <div key={sub.collapseKey}>
                    <ListItem button onClick={handleToogleList(sub.collapseKey)}>
                        {subView}
                        {opennedItems[sub.collapseKey] ? (
                            <ExpandLess className={classes.arrow} />
                        ) : (
                            <ExpandMore className={classes.arrow} />
                        )}
                    </ListItem>
                    <Collapse in={opennedItems[sub.collapseKey]} timeout="auto" unmountOnExit>
                        {renderSubMenuItems(sub.subItems)}
                    </Collapse>
                </div>
            );
        });
    };

    const renderSubMenuItems = (items: SubMenuItem[]): JSX.Element[] => {
        return items.map((subItem, indexSubItem) => {
            const subLabelView = (mobileOpen || showMenuLabel) && subItem.label;
            const isActive = isActivePath(subItem.active || subItem.to);
            const { color, colorActiveLabel } = getItemWithColor(t) || {};
            const colorName = isActive ? colorActiveLabel || 'inherit' : 'inherit';

            return (
                <ListItem key={indexSubItem} button className={classes.nested}>
                    <Button
                        component={RouterLink}
                        id={subItem.label}
                        className={isActive}
                        style={isActive ? { backgroundColor: color } : {}}
                        to={subItem.to}
                    >
                        {/* {(subItem.customIcon ? Logo(subItem.customIcon) : <Icon>{subItem.icon}</Icon>)} */}
                        <span style={{ color: colorName }}>{subLabelView}</span>
                        {favorites && (
                            <Icon className="menuItemOption" onClick={showMenuItemOptions(subItem)}>
                                more_vert
                            </Icon>
                        )}
                    </Button>
                </ListItem>
            );
        });
    };

    const renderDrawer = (): JSX.Element => {
        return (
            <div
                className={clsx(classes.drawer, !showMenuLabel && classes.drawerShrink)}
                style={{ display: 'flex', flex: 1, flexDirection: 'column' }}
            >
                <List>
                    {renderItems()}
                    <ListItem key={'disconnect'}>
                        <Button id={'disconnect'} onClick={handleLogout}>
                            <ExitIcon />
                            <span style={{ color: 'inherit', marginLeft: 8 }}>
                                {(mobileOpen || showMenuLabel) && t('disconnect')}
                            </span>
                        </Button>
                    </ListItem>
                </List>
                <List
                    style={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        color: 'white',
                    }}
                >
                    <p
                        style={{ alignSelf: 'flex-end' }}
                        onDoubleClick={() => {
                            console.log(localStorage.user);
                        }}
                    >{`${accountType}`}</p>
                </List>
                {isEvent?.isActive && (
                    <List>
                        <ListItem key={'raining'}>
                            <Button
                                id={'raining'}
                                onClick={isEvent.onChange}
                                style={{ justifyContent: 'center', padding: 0 }}
                            >
                                <SnowIcon fontSize="small" style={{ color: isEvent.raining ? 'white' : 'coral' }} />
                            </Button>
                        </ListItem>
                    </List>
                )}
                <List style={{ display: 'flex', justifyContent: 'center', color: 'white' }}>
                    <p style={{ alignSelf: 'flex-end' }}>
                        {`v${packageJson.version}`}
                        {envConfig.environment === 'prod' && showMenuLabel && (
                            <a
                                href={'https://unicorn.malahieude.net/login.php?token=' + UserUtils.getToken()}
                                style={{ marginLeft: 4, opacity: 0.5 }}
                            >
                                🦄
                            </a>
                        )}
                    </p>
                </List>
                {renderItemMenu()}
            </div>
        );
    };

    const renderItemMenu = (): JSX.Element => {
        return (
            favorites && (
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl?.elt}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={hideMenuItemOptions}
                >
                    {anchorEl && (
                        <MenuItem onClick={openMenuItem(anchorEl.item)}>
                            <strong>{t('open')}</strong>
                        </MenuItem>
                    )}
                    {anchorEl && !favorites[anchorEl.item.to] && (
                        <MenuItem onClick={addOrRemoveFavorites(anchorEl.item)}>{t('add_favorites')}</MenuItem>
                    )}
                    {anchorEl && favorites[anchorEl.item.to] && (
                        <MenuItem onClick={addOrRemoveFavorites(anchorEl.item)}>{t('remove_favorites')}</MenuItem>
                    )}
                </Menu>
            )
        );
    };

    const renderMobile = (): JSX.Element => {
        return (
            <Hidden smUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    <IconButton onClick={handleDrawerToggle} className={classes.closeMenuButton}>
                        <CloseIcon />
                    </IconButton>
                    {renderDrawer()}
                </Drawer>
            </Hidden>
        );
    };

    const renderDesktop = (): JSX.Element => {
        return (
            <Hidden xsDown implementation="css">
                <Drawer
                    className={clsx(
                        classes.drawer,
                        subMenuOpened ? classes.drawerOpen : showMenuLabel ? classes.drawerClose : classes.drawerShrink,
                    )}
                    variant="permanent"
                    onMouseOver={hoverMenu(true)}
                    onMouseLeave={hoverMenu(false)}
                    classes={{
                        paper: showMenuLabel ? classes.drawerPaper : classes.drawerShrinkPaper,
                    }}
                >
                    <div className={classes.toolbar} />
                    {renderDrawer()}
                    {false && subMenuOpened && (
                        <IconButton color="inherit" edge="end" name="menu" onClick={toogleSubMenu()}>
                            <CloseIcon />
                        </IconButton>
                    )}
                </Drawer>
                {showMenuLabel && (
                    <Drawer
                        className={clsx(
                            subMenuOpened ? classes.subDrawer : classes.subDrawerShrink,
                            classes.drawerClose,
                        )}
                        variant="permanent"
                        classes={{
                            paper: `${classes.subDrawerPaper} ${
                                subMenuOpened ? classes.subDrawerPaperExpand : classes.subDrawerPaperShrink
                            }`,
                        }}
                    >
                        {subMenuOpened && activeSubMenu && subMenus[activeSubMenu] && (
                            <div className={classes.subMenu}>
                                <div className={classes.toolbar} />
                                {subMenus[activeSubMenu]}
                                <IconButton
                                    color="inherit"
                                    edge="end"
                                    name="subMenu"
                                    className={classes.subDrawerCloseButton}
                                    onClick={toogleSubMenu()}
                                >
                                    {Logo(Images.ArrowLeftIcon, { marginRight: 0 })}
                                </IconButton>
                            </div>
                        )}
                    </Drawer>
                )}
            </Hidden>
        );
    };

    const renderTopBar = (): JSX.Element => {
        return (
            <Hidden smUp implementation="css">
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label={t('open_drawer')}
                            edge="start"
                            name="drawer"
                            onClick={handleDrawerToggle}
                            className={classes.menuButton}
                        >
                            {Logo(Images.BurgerIcon, {})}
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </Hidden>
        );
    };

    return (
        <div className={classes.root}>
            {/* Top Bar view */}
            {renderTopBar()}

            {/* Menu view */}
            <nav className={classes.drawer}>
                {renderMobile()}
                {renderDesktop()}
            </nav>
            {/* Content view */}
            <div className={classes.content}>
                <div className={classes.toolbar} />
                {children}
            </div>
        </div>
    );
});

const MenuDrawerWithStyleAndTranslation = withTheme(withStyles(styles)(withTranslation('menu')(MenuDrawer)));

const mapStateToProps = (state) => ({
    favorites: homeSelectors.favorites(state),
});

const mapDispatchToProps = {
    getUserStorage: homeActions.getUserStorage,
    getAllUserStorage: homeActions.getAllUserStorage,
    toggleFavorite: homeActions.toggleFavorite,
    removeUserStorage: homeActions.removeUserStorage,
    clearUserStorage: homeActions.clearUserStorage,
    logout: loginActions.logout,
    logoutBO: loginActions.logoutBO,
    disconnectFreeSeatingUser: viadialogActions.disconnectFreeSeatingUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuDrawerWithStyleAndTranslation);
